export default __webpack_public_path__ + "static/media/home-slideshow-2.bc44eab0.jpg";